import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PdfViewer from '../../General/PDFViewer/pdfViewer';
import PdfEmbeddedViewer from '../../General/PdFEmbeddedViewer/PdfEmbeddedViewer';
import ErrorMessage from '../../General/ErrorMessage/ErrorMessage';
import Post from '../../../Data/Post';
import { FormatReportData } from '../../Reports/Functions/FormatReportData';
import { WriteReport } from '../../Reports/ReportWriter';

const PrintPreview = (props) => {

    const [errorStatus, updateErrorStatus] = useState({visible: false, message: ''});
    const [reportData, setReportData] = useState();
    const [configuration, setConfiguration] = useState();


    useEffect(() => {
        const criteria = { ReportName: 'DefaultSpecimenReport' };
        Post('config/getreport', criteria, configDataRetrieved, errorWhenRetrievingData);
    }, [])

    useEffect(() => {
        if (props.reportConfiguration?.value) {
            const criteria = {...props.reportConfiguration};
            criteria.id = props.id;
            Post('report/getreportwithamendments', criteria, reportDataRetrieved, errorWhenRetrievingData);
        }
    }, [props.reportConfiguration], props.id)

    const configDataRetrieved = (data) => {
        //const parameters = [{ Key: 'id', Value: props.id }];
        //const criteria = { Name: "SpecimenRecordReport", Parameters: parameters};
        const criteria = {...props.reportConfiguration};
        criteria.id = props.id;
        setConfiguration(data);
        Post('report/getreportwithamendments', criteria, reportDataRetrieved, errorWhenRetrievingData, data);
    }

    const reportDataRetrieved = (data, reportConfig) => {
        let formattedData = JSON.parse(data);
        FormatReportData(formattedData);
        reportConfig = reportConfig === undefined ? configuration : reportConfig;
        const report = WriteReport(formattedData, reportConfig, "printpreview", props.language);
        setReportData({...report});
    }

    const errorWhenRetrievingData = (response) => {
        updateErrorStatus({visible: true, message: response.data});
    }

    const errorCloseHandler = () => {
        updateErrorStatus({visible: false, message: ''});
    }

    let pdfViewer = (null)
    if (props.embed) {
        pdfViewer = <PdfEmbeddedViewer data={reportData}></PdfEmbeddedViewer>
    } else {
        pdfViewer = <PdfViewer data={reportData}></PdfViewer>
    }

    return (
        <div className='managelist-content'>
            {pdfViewer}
            <ErrorMessage visible={errorStatus.visible} dismissHandler={errorCloseHandler} error={errorStatus.message}></ErrorMessage>
        </div>
    )
};

const mapStateToProps = state => {
    return {
        language: state.config.language
    };
}

export default connect(mapStateToProps)(PrintPreview);


